import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import Moment from "moment";
import { toast } from "react-toastify";
import { Grid, Paper, Typography } from "@mui/material";
import "react-toastify/dist/ReactToastify.css";
import Table from "../common/tableWithBackEndPagination";
import ConfirmDialoag from "../common/ConfirmDialoag";
import Loader from "../../Layout/Loader";
import TextField from "../common/TextField";
import CustomButton from "../common/Button";
import CreateUpdateForm from "./CreateUpdateForm";

import { checkPrivileges, PaginationConfig } from "../../Helpers";
import ListItemsInvoicebase from "./ListItemsInvoicebase";

export const MannualInComp = (props) => {
    const cancelSource = useRef(null);

    const logInUser = useSelector((state) => state.logInUsers);
    const themecolors = useSelector((state) => state.themecolors);
    const ServerSetting = useSelector((state) => state.ServerSetting);

    const [isShowAddForm, setIsShowAddForm] = useState(false);

    const [state, setState] = useState({
        ...PaginationConfig,
        tableData: [],
        pagData: null,
        defaultItemsList: false,
        selectedItem: null,
        onDeleteConfirmation: false,
        confirmationText: "",
        openPaymentList: false,
        selectedPaymentItem: null,
    });


    const getInvoices = () => {
        const { page, pageSize, itemSearch } = state;
        if (!logInUser?.id) return;

        cancelSource.current = axios.CancelToken.source();
        setState((p) => ({ ...p, loading: true }));
        axios
            .get(
                `api/manualinvoices/get?page=${page}&limit=${pageSize}&search=${itemSearch}`,
                { cancelToken: cancelSource.current.token }
            )
            .then(({ data }) => {
                if (data?.status !== "success" || !data?.data?.data) {
                    setState((p) => ({ ...p, defaultItemsList: true }));
                    return;
                }

                const current = Moment();

                const tableData = data.data.data.map((item) => {
                    const timeStamp = item.timeStamp
                        ? logInUser?.twelveHourFormat
                            ? Moment(item.timeStamp).format("YYYY-MM-DD hh:mm A")
                            : Moment(item.timeStamp).format("YYYY-MM-DD HH:mm")
                        : "";

                    const diff = 30 - Moment.duration(current.diff(timeStamp))._data.days;

                    return {
                        ...item,
                        timeStamp,
                        expire: `Auto delete in ${diff} days`,
                        checked: false,
                        accountName:
                            item.attributes?.accountName ||
                            item.attributes?.c_accountName ||
                            "",
                    };
                });

                setState((p) => ({
                    ...p,
                    tableData,
                    pagData: data.data,
                    defaultItemsList: true,
                    loading: false
                }));
            })
            .catch((e) => {
                if (!axios.isCancel(e)) console.error(e);
            }).finally(() => {
                setState((p) => ({ ...p, loading: false }));
            })
    };

    useEffect(() => {
        getInvoices();
        return () => cancelSource.current?.cancel();
    }, [state.page, state.pageSize, state.itemSearch]);

    const handleChangeRowsPerPage = (pageSize) => {
        setState((prev) => ({
            ...prev,
            pageSize,
            page: 1, // optional: reset page
        }));
    };

    const handleChangePage = (page) => {
        setState((prev) => ({
            ...prev,
            page,
        }));
    };

    /* =========================
        DELETE / RESTORE
    ========================== */

    const deleteItem = () => {
        const { selectedItem } = state;
        const url = `/api/manualinvoices/${selectedItem[0]?.id}`;

        fetch(url, { method: "DELETE" })
            .then((r) => r.json())
            .then((res) => {
                if (res.status === "success") {
                    toast.success(
                        props.translate(
                            "deleteSuccessfully"
                        )
                    );
                    getInvoices();
                }
            })
            .catch(() => toast.error("somethingWentWrong"));

        setState((p) => ({ ...p, onDeleteConfirmation: false }));
    };






    const setPagination = (data) => {
        if (!data) return {};
        const lastPage = Math.ceil(data.total / state.pageSize);
        return { ...data, pageSize: state.pageSize, lastPage };
    };

    /* =========================
        PAYMENT
    ========================== */

    const onShowPaymentDetails = (items) => {
        setState((p) => ({
            ...p,
            openPaymentList: true,
            selectedPaymentItem: items?.[0] || null,
        }));
    };

    const handleClosePaymentList = () => {
        setState((p) => ({
            ...p,
            openPaymentList: false,
            selectedPaymentItem: null,
        }));
    };
    const [searchText, setSearchText] = useState("");

    // 2. Update input only
    const handleSearchChange = (text) => setSearchText(text);
    const handleSearchClick = () => {
        setState((prev) => ({
            ...prev,
            itemSearch: searchText, // triggers getInvoices in useEffect
            page: 1 // optional: reset to first page
        }));
    };
    // if (!state.defaultItemsList) return <Loader />;

    return (
        <div>
            {/* HEADER */}
            <Grid
                container
                className="breadcrumb-row"
                alignItems="center"
            >
                {/* Title */}
                <Grid item xs={12} sm={6}>
                    <Typography variant="h5" sx={{ fontWeight: 600 }}>
                        {props.translate("manualInvoice")}
                    </Typography>
                </Grid>

                {/* Search + Buttons */}
                <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                        display: "flex",
                        justifyContent: { xs: "flex-start", sm: "flex-end" },
                        gap: 1,
                        marginTop: { xs: 1, sm: 0 },
                    }}
                >{
                        !isShowAddForm &&
                        <>
                            <TextField
                                label={props.translate("search")}
                                sx={{ width: { sm: 250 } }}
                                style={{ width: "250px" }}
                                value={searchText}
                                onChange={(e) => handleSearchChange(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") handleSearchClick();
                                }}
                            />
                            <CustomButton
                                onClick={handleSearchClick}
                                disabled={state.loading}
                            >
                                {props.translate("search")}
                            </CustomButton>
                        </>
                    }
                    {checkPrivileges("manualinvoiceCreate") &&
                        <CustomButton
                            onClick={() => setIsShowAddForm((p) => !p)}
                            disabled={state.loading}
                        >
                            {props.translate(isShowAddForm ? "back" : "create")}
                        </CustomButton>}
                </Grid>
            </Grid>

            {/* TABLE */}
            {state.loading ? (
                <Loader />
            ) : (
                !isShowAddForm && (
                    <Table
                        rows={state.tableData}
                        pagination={setPagination(state.pagData)}
                        onDelete={(s) =>
                            setState((p) => ({ ...p, selectedItem: s, onDeleteConfirmation: true }))
                        }
                        onRestore={(s) =>
                            setState((p) => ({ ...p, selectedItem: s, onRestoreConfirmation: true }))
                        }
                        hasAccessOfDelete={checkPrivileges("manualinvoiceDelete")}
                        rowDefinition={rowDefinitionR(props.translate)}
                        themecolors={themecolors}
                        ServerSetting={ServerSetting}
                        logInUser={logInUser}
                        isShowPaymentList
                        isEditable
                        manualInvoice
                        onShowPaymentDetails={onShowPaymentDetails}
                        handleChangePage={handleChangePage}
                        handleChangeRowsPerPage={handleChangeRowsPerPage}
                    />
                ))}

            {/* DIALOGS */}
            {state.onDeleteConfirmation && (
                <ConfirmDialoag
                    title={props.translate("areYouWantToDelete")}
                    onCancel={() => setState((p) => ({ ...p, onDeleteConfirmation: false }))}
                    onOk={deleteItem}
                />
            )}


            {/* PAYMENT */}
            {state.openPaymentList && (
                <ListItemsInvoicebase
                    open={state.openPaymentList}
                    selectedPaymentItem={state.selectedPaymentItem}
                    onClose={handleClosePaymentList}
                    getInvoices={getInvoices}
                />
            )}

            {/* FORM */}
            {isShowAddForm && <CreateUpdateForm {...props}
                getInvoices={getInvoices}
                setIsShowAddForm={setIsShowAddForm}
            />}
        </div>
    );
};


const rowDefinitionR = (translate) => [
    { id: "refNum", label: translate("refNum") },
    { id: "accountName", label: translate("customerName") },
    { id: "contractNumber", label: translate("contractNumber") },
    { id: "saleTotal", label: translate("saleTotal") },
    { id: "saleVat", label: translate("saleVat") },
    { id: "saleNet", label: translate("saleNet") },
    { id: "refDate", label: translate("refDate") },
    { id: "issueInvoice", label: translate("invoiced") },
];
